import SimpleBar from 'simplebar';

Array.prototype.forEach.call(
  document.querySelectorAll('#popup-location .popup__main'),
  (el) => new SimpleBar(el)
);
